import * as React from "react";
import {Option} from "ts-option";
import DateSelector from "./DateSelector";
import JobDetailsModel from "../../../model/job/JobDetailsModel";
import Toast from "../../helper/Toast";
import {OnSuccess} from "../../../store/action/actionHelpers";
import moment = require("moment");

interface ComponentProps {
	/**
	 * Job details.
	 */
	jobDetails: Option<JobDetailsModel>
	/**
	 * Edit job details
	 * @param {JobDetailsModel} jobDetails
	 * @param {OnSuccess} onSuccess
	 */
	editJobDetails: (jobDetails: JobDetailsModel, onSuccess: OnSuccess) => void
}

type Props = ComponentProps

export default class JobInstallationDatePresenter extends React.PureComponent<Props> {

	render() {
		return (<DateSelector value={this.props.jobDetails.flatMap(jd => jd.executionDate)}
							  title={"Expected Completion Date"}
							  onChange={this.onChange}/>)
	}

	onChange = (executionDate: Option<moment.Moment>) => {
		this.props.jobDetails.map(jd => this.props.editJobDetails(jd.copy({executionDate}), this.onSuccess));
	};

	onSuccess = () => Toast.success("Job Expected Completion Date updated", "Job details update");
}